// Covenant Calibration (capture-only) — raw HTTP transport for the three
// loan Profile-tab data-entry cards (calibration amounts / seasonality /
// DSCR-DACA banking). Every endpoint returns the full CovenantCalibrationDto
// (the ApiResponse envelope is unwrapped by the shared client). Hooks in
// @/hooks/portfolioAdmin/usePortfolioAdmin wrap these with TanStack Query.

import { api } from "../client";
import type {
  CovenantCalibrationDto,
  UpdateCalibrationAmountsRequest,
  UpdateSeasonalityRequest,
  UpsertBankAccountRequest,
} from "./types";

const base = (loanId: string) =>
  `/portfolio-admin/loans/${loanId}/covenant-calibration`;

export const covenantCalibrationApi = {
  get: (loanId: string) =>
    api.get<CovenantCalibrationDto>(base(loanId)),
  updateAmounts: (loanId: string, body: UpdateCalibrationAmountsRequest) =>
    api.put<CovenantCalibrationDto>(`${base(loanId)}/amounts`, body),
  confirmCalibration: (loanId: string) =>
    api.post<CovenantCalibrationDto>(`${base(loanId)}/amounts/confirm`),
  updateSeasonality: (loanId: string, body: UpdateSeasonalityRequest) =>
    api.put<CovenantCalibrationDto>(`${base(loanId)}/seasonality`, body),
  confirmSeasonality: (loanId: string) =>
    api.post<CovenantCalibrationDto>(`${base(loanId)}/seasonality/confirm`),
  addAccount: (loanId: string, body: UpsertBankAccountRequest) =>
    api.post<CovenantCalibrationDto>(`${base(loanId)}/accounts`, body),
  updateAccount: (
    loanId: string,
    accountId: string,
    body: UpsertBankAccountRequest,
  ) =>
    api.put<CovenantCalibrationDto>(
      `${base(loanId)}/accounts/${accountId}`,
      body,
    ),
  removeAccount: (loanId: string, accountId: string) =>
    api.delete<CovenantCalibrationDto>(
      `${base(loanId)}/accounts/${accountId}`,
    ),
  confirmBanking: (loanId: string) =>
    api.post<CovenantCalibrationDto>(`${base(loanId)}/banking/confirm`),
};
